import React from "react";
import Container from '@mui/material/Container';
import PublicationContainer from "../components/PublicationContainer";

export const Publications = () =>
    <Container>
        <PublicationContainer/>
    </Container>
